export default {
  title: "Customers",
  subtitle: "Manage customer accounts and information",
  banCustomer: "Ban Customer",
  activateCustomer: "Activate Customer",
  
  // Actions
  addNew: "Add New Customer",
  createCustomer: "Create Customer",
  editCustomer: "Edit Customer",
  deleteCustomer: "Delete Customer",
  customerDetails: "Customer Details",
  customerInformation: "Customer Information",
  newOrder: "New Order",
  orderType: "Order Type",
  ship4me: "Ship4Me Order",
  buy4me: "Buy4Me Order",
  customerOrders: "Customer Orders",

  orderForm: {
    country: "Country",
    link: "Product Link",
    options: "Item Options",
    quantity: "Quantity",
    price: "Item Price",
    actions: "Actions",
    selectCountry: "Select Country",
    linkPlaceholder: "Product URL",
    optionsPlaceholder: "Color, Size, any instructions",
    pricePlaceholder: "0.00",
    deleteRow: "Delete Row",
    addRow: "Add Row",
    submit: "Submit"
  },

  ordersTable: {
    orderNumber: "Order #",
    type: "Type",
    group: "Group",
    merchant: "Merchant",
    quantity: "Quantity",
    status: "Status",
    price: "Price",
    actions: "Actions",
    viewDetails: "View Order Details",
    noOrders: "No orders found",
    noOrdersDesc: "This customer hasn't placed any orders yet."
  },

  actions: {
    title: "Actions",
    back: "Back",
    update: "Update",
    updating: "Updating...",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    create: "Create",
    creating: "Creating...",
    view: "View Details",
    editProfile: "Edit Customer Profile",
    editAddress: "Edit User Address"
  },
  
  // Fields
  fields: {
    name: "Customer Name",
    email: "Email Address",
    phone: "Phone Number",
    address: "Address",
    address2: "Address Line 2",
    city: "City",
    country: "Country",
    postalCode: "Postal Code",
    company: "Company",
    taxNumber: "Tax Number",
    customerType: "Customer Type",
    creditLimit: "Credit Limit",
    paymentTerms: "Payment Terms",
    status: "Status",
    notes: "Notes",
    password: "Password",
    userAddress: "User Address",
    verifiedAt: "Verified At",
    createdAt: "Created At",
    updatedAt: "Updated At"
  },
  
  // Placeholders
  placeholders: {
    name: "Enter customer name",
    email: "Enter email address",
    phone: "Enter phone number",
    address: "Enter address",
    address2: "Enter additional address (optional)",
    city: "Select city",
    country: "Select country",
    postalCode: "Enter postal code",
    company: "Enter company name",
    taxNumber: "Enter tax number",
    creditLimit: "Enter credit limit",
    paymentTerms: "Enter payment terms",
    password: "Enter password",
    notes: "Enter additional notes"
  },
  
  // Messages
  messages: {
    createSuccess: "Customer created successfully",
    createError: "Failed to create customer",
    updateSuccess: "Customer updated successfully",
    updateError: "Failed to update customer",
    deleteSuccess: "Customer deleted successfully",
    deleteError: "Failed to delete customer",
    deleteConfirm: "Are you sure you want to delete this customer?",
    statusConfirm: "Are you sure you want to {{action}} this customer?",
    statusSuccess: "Customer {{action}}d successfully",
    statusError: "Failed to update customer status",
    noCustomers: "No customers found",
    loadingCustomers: "Loading customers...",
    loading: "Loading customer details...",
    fetchError: "Failed to fetch customers"
  },
  
  // Validation
  validation: {
    nameRequired: "Customer name is required",
    nameMinLength: "Customer name must be at least 2 characters",
    nameMaxLength: "Customer name must not exceed 100 characters",
    emailRequired: "Email address is required",
    emailFormat: "Please enter a valid email address",
    emailInvalid: "Please enter a valid email address",
    phoneRequired: "Phone number is required",
    phoneFormat: "Phone must start with 7 and be exactly 10 digits",
    phoneInvalid: "Phone must start with 7 and be exactly 10 digits",
    passwordRequired: "Password is required",
    passwordMinLength: "Password must be at least 8 characters",
    passwordComplexity: "Password must include uppercase, lowercase, number, and special character",
    passwordTooEasy: "Password cannot be an easy password like 123456",
    passwordMatchesPhone: "Password cannot match the registered mobile number",
    addressRequired: "Address is required",
    cityRequired: "City is required",
    countryRequired: "Country is required",
    creditLimitMin: "Credit limit must be 0 or greater",
    taxNumberFormat: "Please enter a valid tax number",
    fillAllFields: "Please fill in all required fields"
  },
  
  // Table headers
  table: {
    id: "ID",
    mailboxNumber: "Mailbox No.",
    name: "Name",
    email: "Email",
    phone: "Phone",
    company: "Company",
    city: "City",
    country: "Country",
    customerType: "Type",
    creditLimit: "Credit Limit",
    status: "Status",
    actions: "Actions"
  },
  
  // Status options
  statusOptions: {
    active: "Active",
    inactive: "Inactive",
    suspended: "Suspended"
  },
  
  // Customer types
  customerTypes: {
    individual: "Individual",
    business: "Business",
    corporate: "Corporate"
  },
  
  // Breadcrumbs
  breadcrumbs: {
    customers: "Customers",
    create: "Create Customer",
    edit: "Edit Customer",
    view: "View Customer"
  }
};
